import { Avatar, Stack, Typography } from '@mui/material';
import React from 'react';
import { AppColors } from '../Utils/helper/AppColors';
import CultureOSLogo from '../Assets/Image/CultureOS.png';
import { useSelector } from 'react-redux';

export default function TextLogo(props) {
	const { size, img, color, align, onClick , textLogo } = props;
	const url = useSelector((state) => state.app?.logoUrl);
	const company = useSelector((state) => state?.app?.company);
	return (
		<>
			{img ? (
				<Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
					<Avatar
						src={company?.companyLogo || url || CultureOSLogo}
						alt="logo"
						style={{
							width: 41,
							height: 41,
							// marginRight: 5,
							cursor: typeof onClick == 'function' ? 'pointer' : 'auto',
						}}
						sx={{
							'& .MuiAvatar-img': {
								objectFit: 'contain',
							},
						}}
					/>
				</Stack>
			) : (
				<Typography
					onClick={() => {
						if (typeof onPress == 'function') {
							onClick();
						}
					}}
					sx={{ cursor: typeof onClick == 'function' ? 'pointer' : 'auto' }}
					textAlign={align}
					fontSize={size || 30}
					fontWeight={700}
					fontFamily="Poppins"
					color={color || AppColors.PRIMARY_DARK}
					{...props}
				>
					{textLogo}
				</Typography>
			)}
		</>
	);
}
